module.exports = __webpack_public_path__ + "static/media/snack-madness-banner.e95b003b.png";